import { render, staticRenderFns } from "./EditorTableFlowChip.vue?vue&type=template&id=8609f568&scoped=true&"
import script from "./EditorTableFlowChip.vue?vue&type=script&lang=js&"
export * from "./EditorTableFlowChip.vue?vue&type=script&lang=js&"
import style0 from "./EditorTableFlowChip.vue?vue&type=style&index=0&id=8609f568&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8609f568",
  null
  
)

export default component.exports